import React, { useState } from "react"
import * as Icons from "lucide-react"

// Shared "New folder" / "Rename folder" modal — replaces the native
// window.prompt() dialog with the app's normal styled modal.
export default function EmailFolderModal({
  mode,
  initialName,
  onSave,
  onClose,
  saving,
}) {
  const [name, setName] = useState(initialName || "")
  const isRename = mode === "rename"
  const trimmed = name.trim()
  const unchanged = isRename && trimmed === (initialName || "").trim()

  const submit = () => {
    if (!trimmed || unchanged) return
    onSave(trimmed)
  }

  return (
    <div className="em-search-overlay em-folder-modal-overlay" onClick={onClose}>
      <div className="em-cal-modal" onClick={e => e.stopPropagation()}>
        <div className="em-cal-modal-header">
          <h3>{isRename ? "Rename folder" : "New folder"}</h3>
          <button className="em-search-close" onClick={onClose}>
            <Icons.X size={18} />
          </button>
        </div>
        <div className="em-cal-modal-body">
          <div className="em-cal-modal-field">
            <Icons.Folder size={16} />
            <input
              autoFocus
              placeholder="Folder name"
              value={name}
              onChange={e => setName(e.target.value)}
              onKeyDown={e => {
                if (e.key === "Enter") submit()
              }}
            />
          </div>
        </div>
        <div className="em-cal-modal-footer">
          <div className="em-cal-modal-footer-right">
            <button
              className="em-search-clear-btn"
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              className="em-compose-send-btn"
              onClick={submit}
              disabled={!trimmed || unchanged || saving}
            >
              {saving ? "Saving…" : isRename ? "Rename" : "Create"}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
